import axios from 'axios'

let baseUrl = window.location.host
let baseUrlDrupal = window.location.host
let localhost = false

if (baseUrl.includes(":8080") || baseUrl == "haffit-de.server2.voatt.cz") {
    baseUrl = 'https://haffitdeapi.server2.voatt.cz'
    baseUrlDrupal = 'https://haffit-de.server2.voatt.cz'
    localhost = true
} else {
    baseUrl = '//api.haffit.de'
    baseUrlDrupal = '//www.haffit.de'
}

//Silex framework
export const apiSilex = axios.create({
    baseURL: baseUrl + '/de',
    timeout: 50000,
    headers: {
	'Content-Type': 'application/json'
    }
})

//Drupal
export const apiDrupal = axios.create({
    baseURL: baseUrlDrupal + '/api/de',
    timeout: localhost ? 50000 : null, //NOTE: For localhost
    //withCredentials: true,
    auth: {
	username: 'haffit-de',
	password: 'haffit-de'
    },
    headers: {
	'Content-Type': 'application/json',
	'Accept': 'application/json',
	'Authorization': 'Basic ZnV0YWxpczpmdXRhbGlz'
    }
})



// WEBPACK FOOTER //
// ./src/api/index.js